<div class="p-24" style="min-width: 350px !important;min-height: 200!important;">
    <h1 matDialogTitle>Auto Logout Warning</h1>
    <div mat-dialog-content>This session will be closed in {{ timeLeft | timeFormat }} and you will be logged out because of an extended period of inactivity. Click the 'OK' button to continue your session.</div>
    <div mat-dialog-actions class="pt-24">
        <button mat-raised-button class="mat-accent" (click)="this.dialogRef.close()">OK</button>
    </div>
</div>
